import React, { Component } from 'react';
import { getProject } from 'Services/project';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { fetchPlayersWithClub } from '../actions';
import filterList from 'Actions/lists';

import { TableList } from '../../../../common/components/TableList';
import Row from './Row';
import Breadcrumb from 'FDComponents/Breadcrumb';
import { resetBreadcrumb } from '../../../components/Breadcrumb/actions';

import AreaInput from 'FDComponents/areas/Input';
import ClubInput from '../../../clubs/Input';
import TeamInput from '../../../teams/Input';

import Layout from 'Components/Layout';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import debounce, { getLinkId } from 'Services/tools';

import queryReducer from 'Services/queriesReducer';
import { parseQuery, stringifyQuery } from 'Services/parseQuery';
import { SearchFilter } from '../../../../common/components/SearchFilter';
import { Alert } from "@material-ui/lab";

@injectIntl
@connect((store, props) => ({
  players: store.players.list,
  fetching: store.players.fetching,
  pagination: store.players.pagination,
  total: store.players.totalItems,
  query: parseQuery(props.location.search),
}))
export default class PlayersList extends Component {
  config = {
    filters: [
      {
        type: 'name',
        labelKey: 'filter_name',
      },
      {
        type: 'mainNationality',
        input: AreaInput,
        labelKey: 'filter_nationality',
      },
      {
        type: 'club',
        input: ClubInput,
        labelKey: 'filter_club',
      },
      {
        type: 'current_team_team',
        input: TeamInput,
        labelKey: 'filter_current_team',
      },
    ],
    headers: [
      { id: 'translations.lastName', labelKey: 'field_lastName' },
      {
        id: 'mainNationality.translations.name',
        labelKey: 'field_mainNationality',
      },
      { labelKey: 'field_club' },
      { id: 'birthDate', labelKey: 'field_birthDate' },
    ],
  };

  componentWillUnmount() {
    debounce(null, null, true);
  }

  componentDidMount() {
    const { dispatch, location } = this.props;

    dispatch(resetBreadcrumb());

    if (location.search === '') {
      this.changeParams({ type: 'SET_SORT', payload: 'translations.lastName' });
    }
    if (location.search !== '') {
      this.fetchData(location.search);
    }
  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props;

    if (nextProps.location.search === '') {
      this.changeParams({ type: 'SET_SORT', payload: 'translations.lastName' });
    }

    if (
      prevProps.location.search !== nextProps.location.search &&
      nextProps.location.search !== ''
    ) {
      this.fetchData(nextProps.location.search);
    }
  }

  fetchData = filter => {
    const { dispatch } = this.props;
    dispatch(fetchPlayersWithClub(filter));
    dispatch(filterList('players', filter));
  };

  handleFilters = change => {
    const { name, mainNationality, club, current_team_team } = change;
    const filtersQuery = {
      name,
      mainNationality: getLinkId(mainNationality),
      club: getLinkId(club),
      current_team_team: getLinkId(current_team_team),
    };
    this.changeParams({ type: 'SET_FILTER', payload: filtersQuery });
  };
  handlePagination = change => {
    if (change.page) {
      this.changeParams({ type: 'SET_PAGE', payload: change.page });
    } else {
      this.changeParams({ type: 'SET_ITEMS', payload: change.itemsPerPage });
    }
  };
  handleSort = field => {
    this.changeParams({ type: 'SET_SORT', payload: field });
  };

  changeParams = debounce(action => {
    const { history, query, location } = this.props;
    const newParams = queryReducer(query, action);
    const search = stringifyQuery(newParams);

    location.search != search && location.search === ''
      ? history.replace(`${getProject().url}/players${search}`)
      : history.push(`${getProject().url}/players${search}`);
  }, 500);

  render() {
    const {
      players,
      fetching,
      pagination,
      total,
      query,
      intl: { messages: m },
    } = this.props;

    return (
      <Layout
        id="players-layout"
        top={<Breadcrumb />}
        main={
          <Paper elevation={2}>
            <Toolbar>
              <Typography variant="h6">{m.app_playersList}</Typography>
            </Toolbar>
            <Alert severity="info">
              <a href={`#${getProject().url}/documentation/people`} target="_blank">
                {m.read_the_docs}
              </a>
            </Alert>
            <SearchFilter
              form="players_filters"
              filters={this.config.filters}
              onChange={this.handleFilters}
              initialValues={query.filters}
            />
            <TableList
              tableData={players}
              tableHeaders={this.config.headers}
              query={query}
              onSort={this.handleSort}
              Row={Row}
              loading={fetching}
              pagination={pagination}
              total={total}
              onPaginate={this.handlePagination}
            />
          </Paper>
        }
      />
    );
  }
}
